import { Button } from '@karma/components';
import { getColor } from '@karma/components/colors';
import styled from 'styled-components';

export const FavoritedButton = styled(Button)`
  &:not(:hover) svg {
    color: ${getColor('secondary1')} !important;
  }
`;
